<style scoped>
</style>

<template>
  <div>
    <el-menu-item :index="data.url">
      <span :class="{active_color: data.url === activeIndex}"></span>
      <i :class="iconClass" />
      <span
        slot="title"
        :class="{active: data.url === activeIndex}"
      >
        {{ data.name }}
      </span>
    </el-menu-item>
  </div>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  name: "MenuItem",
  computed: {
    iconClass() {
      return this.data.iconClass;
    }
  },
  data() {
    return {
      activeIndex: ""
    };
  },
  props: {
    data: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  mounted() {
    this.activeIndex = this.$route.meta[
      this.$route.meta.length - 1
    ].activeRoute;
  },
  methods: {
    ...mapMutations(["updateActiveIndex"])
  },
  watch: {
    $route(val) {
      this.activeIndex = val.meta[val.meta.length - 1].activeRoute;
    },
    activeIndex(val) {
      this.updateActiveIndex(val);
    }
  }
};
</script>
<style scoped>
</style>